<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_icon_write)">
      <path
        d="M18 22H6C4.93962 21.9984 3.92265 21.577 3.17285 20.8271C2.42305 20.0773 2.00159 19.0604 2 18V6C2 4.93913 2.42173 3.92202 3.17188 3.17188C3.92202 2.42173 4.93913 2 6 2H13V3.5H6C5.33696 3.5 4.70126 3.76358 4.23242 4.23242C3.76358 4.70126 3.5 5.33696 3.5 6V18C3.5 18.663 3.76358 19.2987 4.23242 19.7676C4.70126 20.2364 5.33696 20.5 6 20.5H18C18.663 20.5 19.2987 20.2364 19.7676 19.7676C20.2364 19.2987 20.5 18.663 20.5 18V11H22V18C22 19.0609 21.5783 20.078 20.8281 20.8281C20.078 21.5783 19.0609 22 18 22Z"
        fill="#575757"
      />
      <path
        d="M10.0078 14.0091H13.3948L21.6058 5.7791C21.8533 5.56279 22.0537 5.29794 22.1947 5.00098C22.3356 4.70401 22.414 4.38127 22.4251 4.05275C22.4361 3.72423 22.3796 3.39694 22.2589 3.09117C22.1383 2.78541 21.9561 2.50768 21.7237 2.27522C21.4913 2.04275 21.2137 1.8605 20.9079 1.73977C20.6022 1.61904 20.2749 1.5624 19.9464 1.57336C19.6179 1.58431 19.2951 1.66264 18.9981 1.80348C18.7011 1.94432 18.4362 2.14467 18.2198 2.3921L10.0078 10.6191V14.0091Z"
        stroke="#575757"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.6641 3.93604L18.1461 5.41804L20.0511 7.32304"
        stroke="#575757"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_icon_write">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
